// extracted by mini-css-extract-plugin
export default {"Container":"Button_Container__CxzPy","Label":"Button_Label__W32y7"};